<template>
  <div id="adviceList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户反馈</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="table-container">
      <div class="table-filtrate">
        <ul>
          <li>
            <span class="label">输入关键字:</span>
            <el-input
              placeholder="请输入内容"
              v-model="filtrate.keyword"
              @keyup.enter.native="getList(1)"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getList(1)"
              ></el-button>
            </el-input>
          </li>
          <li>
            <el-button class="resetBtn" size="medium" @click="reset"
              >重置
            </el-button>
          </li>
        </ul>
        <ul>
          <li>
            <el-button
              class="addBtn"
              type="primary"
              @click="addBtn"
              v-if="buttonList.includes('advice-addBtn')"
              ><i class="iconfont icon-jiahao"></i> 新增反馈
            </el-button>
          </li>
        </ul>
      </div>
      <el-table
        :data="table.tableData"
        style="width: 100%"
        v-loading="table.loading"
      >
        <el-table-column prop="adviceName" label="类型" align="center">
        </el-table-column>
        <el-table-column prop="plateNum" label="车牌号" align="center">
        </el-table-column>
        <el-table-column prop="parkingLotName" label="停车场" align="center">
        </el-table-column>
        <el-table-column prop="contactPerson" label="联系人" align="center">
        </el-table-column>
        <el-table-column prop="contactNumber" label="联系电话" align="center">
        </el-table-column>
        <el-table-column prop="adviceText" label="反馈内容" align="center">
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.picture.length"
              style="width: 50px; height: 50px"
              :src="scope.row.picture"
              :preview-src-list="scope.row.pictureList"
            >
            </el-image>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="submitAt" label="时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="solution(scope.row.adviceId)"
              v-if="buttonList.includes('adviceList-solution')"
              >处理
            </el-button>
            <el-button
              type="text"
              @click="goToDetail(scope.row)"
              v-if="buttonList.includes('adviceList-detail')"
              >查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          layout="sizes, total, prev, pager, next, jumper"
          background
          :total="table.total"
          :page-size.sync="table.pageSize"
          :current-page.sync="table.page"
          @current-change="getList"
          @size-change="getList(1)"
        >
        </el-pagination>
      </div>
    </div>
    <add-advice-dialog
      ref="addAdviceDialog"
      :getList="getList"
      :adviceTypeList="adviceTypeList"
      :parkingList="parkingLotList"
    />
    <solution-dialog :getList="getList" ref="solutionDialog" />
  </div>
</template>
<script>
export default {
  components: {
    addAdviceDialog: () => import("./addAdviceDialog.vue"),
    solutionDialog: () => import("./solutionDialog.vue"),
  },
  data() {
    return {
      filtrate: {
        keyword: "",
      },
      table: {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 10,
        loading: false,
      },
      adviceTypeList: [],
    };
  },
  created() {
    this.getList();
    this.getAdviceTypeList();
  },
  computed: {
    parkingLotList() {
      return this.$store.state.select.parkingLotList;
    },
  },
  methods: {
    solution(adviceId) {
      this.$refs.solutionDialog.adviceId = adviceId;
      this.$refs.solutionDialog.show = true;
    },
    async getAdviceTypeList() {
      try {
        let res = await this.$http.post("/advice/typeList");
        if (res.code === 0) {
          this.adviceTypeList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    addBtn() {
      this.$refs.addAdviceDialog.show = true;
    },
    goToDetail(info) {
      this.$router.push({
        name: "adviceDetail",
        params: { info: JSON.stringify(info) },
      });
    },
    reset() {
      this.filtrate.keyword = "";
      this.getList(1);
    },
    async getList(page = this.table.page) {
      this.table.page = page;
      try {
        this.table.loading = true;
        let res = await this.$http.post("/advice/list", {
          pageNum: page,
          pageSize: this.table.pageSize,
        });
        if (res.code === 0) {
          for (let item of res.data.list) {
            let picture = "";
            let pictureList = [];
            for (let items of item.pictureList) {
              pictureList.push(items.advicePicture);
            }
            if (pictureList.length) {
              picture = pictureList[0];
            }
            item.submitAt = this.$moment(item.submitAt).format(
              "yyyy-MM-DD HH:mm:ss"
            );
            item.picture = picture;
            item.pictureList = pictureList;
          }
          Object.assign(this.table, {
            tableData: res.data.list,
            total: res.data.total,
          });
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.table.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#adviceList {
  .table-container {
    .table-filtrate {
      ul {
        li {
          .addBtn {
            background-color: #ff9747;
            border-color: #ff9747;

            i {
              font-size: 14px;
            }
          }
        }
      }
    }

    .el-table {
      .el-table__body {
        .payStatus {
          display: flex;
          justify-content: center;
          align-items: center;
          color: $main-color;

          &::before {
            content: "";
            display: inline-block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: $main-color;
            margin-right: 5px;
          }
        }

        .notPay {
          color: #ff0000;

          &::before {
            background-color: #ff0000;
          }
        }

        .awaitPay {
          color: #8d8d8d;

          &::before {
            background-color: #8d8d8d;
          }
        }
      }
    }
  }
}
</style>
